export const handleVideoCardsModalBlock = function () {

    if ( !document.querySelector('.block-video-cards') ) { 
        
        return;
    }

    var elements = document.querySelectorAll("[data-bs-target^='#video_card_modal_']");

    for ( var i = 0; i < elements.length; i++ ) {

        var elem = document.getElementById(elements[i].id);

            elem.addEventListener('click', function(i) {

                var video_card_modal = '#video_card_modal_vc_' + elements[i].id;
                var video_card_modal_video = video_card_modal + '_video';

                $( video_card_modal ).on('shown.bs.modal', function () {

                    $( video_card_modal_video )[0].play();

                })

                $( video_card_modal ).on('hide.bs.modal', function () {

                   $( video_card_modal_video )[0].pause();

                })


            }.bind(null, i));

     }

}
